const API_URL = 'https://321hphegd7.execute-api.us-east-1.amazonaws.com/dev';
const PHONE_NUMBER = '(703) 568-1980';
const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@khayrfoundation";

module.exports = {
    API_URL,
    PHONE_NUMBER,
    YOUTUBE_CHANNEL_URL
}